import React from "react";
import { FaLocationDot } from "react-icons/fa6";
import { Link } from "react-router-dom";
import placeholderImg from "../../asset/ghumneplaceholder.jpg";
import { truncate } from "../../../utils";
const PackageCard = (items) => {
  const { title, img, location, price, days, slug } = items;

  return (
    <>
      <div className="location_card border  rounded-3 p-2">
        <div className="locatione_img overflow-hidden rounded-3">
          <img
            src={img}
            alt={title}
            className="w-100 h-100 object-fit-cover"
            // onError={(e) => (e.target.src = placeholderImg)}
          />
        </div>
        <div className="location_content position-relative">
          <h6 className="title text-capitalize fw-semibold mt-2 mb-2 text-black ">
            {truncate(title, 8)}
          </h6>
          <div
            className="justify-content-between align-items-center mb-2"
            style={{ display: "flex" }}
          >
            <span className="location mb-2 text-capitalize text-black">
              <FaLocationDot className="text-warning" /> {location}
            </span>
            <span>{days}</span>
          </div>
          <div className="price fw-bold text-black position-absolute bottom-0 start-0">
            <span className="fw-normal text-muted">Price Starts</span>
            <br />
            On Demand
          </div>{" "}
          <Link  to={`/packages/detail/${slug}`}  className="bg-package text-white text-decoration-none px-3 py-1 rounded-2 end-0">
            Show Details
          </Link>
        </div>
      </div>
    </>
  );
};

export default PackageCard;
